import { memo } from "react";
import { Link } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import type { MenuItemProps } from "@mui/material/MenuItem";

interface MenuItemLinkProps extends MenuItemProps {
  to: string;
}

function MenuItemLink(props: MenuItemLinkProps) {
  const { to, ...rest } = props;
  return <MenuItem component={Link} {...rest} to={to} />;
}

export default memo(MenuItemLink);
